export default "__VITE_ASSET__E3R9wfGj__"